import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import { Plus, Trash2, Pencil, Link2, Globe } from "lucide-react";
import { toast } from "sonner";

const CATEGORIE = {
  oss: { label: "OSS Sanitario", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  estetica: { label: "Estetica", cls: "bg-rose-50 text-rose-800 border-rose-200" },
  acconciatori: { label: "Acconciatori", cls: "bg-amber-50 text-amber-900 border-amber-200" },
  educativo: { label: "Educativo", cls: "bg-blue-50 text-blue-800 border-blue-200" },
};
const EMPTY = { titolo:"", categoria:"oss", durata_ore:0, prezzo:0, sede:"", data_inizio_prevista:"", posti_disponibili:20, descrizione:"", attivo:true };

export default function CorsiPubbliciPage() {
  const [corsi, setCorsi] = useState([]);
  const [open, setOpen] = useState(false);
  const [editC, setEditC] = useState(null);
  const [form, setForm] = useState(EMPTY);

  const load = () => api.get("/corsi-pubblici").then(r => setCorsi(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/corsi-pubblici", { ...form, durata_ore:+form.durata_ore, prezzo:+form.prezzo, posti_disponibili:+form.posti_disponibili });
      toast.success("Corso pubblico creato"); setOpen(false); setForm(EMPTY); load();
    } catch { toast.error("Errore creazione"); }
  };
  const saveEdit = async () => {
    try {
      await api.put(`/corsi-pubblici/${editC.id}`, { ...editC, durata_ore:+editC.durata_ore, prezzo:+editC.prezzo, posti_disponibili:+editC.posti_disponibili });
      toast.success("Corso aggiornato"); setEditC(null); load();
    } catch { toast.error("Errore aggiornamento"); }
  };
  const del = async (id) => {
    if (!window.confirm("Eliminare il corso pubblico? Le iscrizioni esistenti restano.")) return;
    await api.delete(`/corsi-pubblici/${id}`); toast.success("Eliminato"); load();
  };

  const renderForm = (f, setF, tid) => (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="col-span-2"><Label>Titolo corso pubblico</Label><Input data-testid={`${tid}-titolo`} value={f.titolo} onChange={e=>setF({...f,titolo:e.target.value})}/></div>
      <div><Label>Categoria</Label>
        <Select value={f.categoria} onValueChange={v=>setF({...f,categoria:v})}>
          <SelectTrigger data-testid={`${tid}-categoria`}><SelectValue/></SelectTrigger>
          <SelectContent>{Object.entries(CATEGORIE).map(([k,v])=><SelectItem key={k} value={k}>{v.label}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div><Label>Durata (ore)</Label><Input type="number" value={f.durata_ore} onChange={e=>setF({...f,durata_ore:e.target.value})}/></div>
      <div><Label>Prezzo €</Label><Input type="number" value={f.prezzo} onChange={e=>setF({...f,prezzo:e.target.value})}/></div>
      <div><Label>Posti disponibili</Label><Input type="number" value={f.posti_disponibili} onChange={e=>setF({...f,posti_disponibili:e.target.value})}/></div>
      <div><Label>Sede</Label><Input value={f.sede} placeholder="es. Catanzaro" onChange={e=>setF({...f,sede:e.target.value})}/></div>
      <div><Label>Inizio previsto</Label><Input type="date" value={f.data_inizio_prevista} onChange={e=>setF({...f,data_inizio_prevista:e.target.value})}/></div>
      <div className="col-span-2"><Label>Descrizione pubblica</Label><Textarea value={f.descrizione} onChange={e=>setF({...f,descrizione:e.target.value})}/></div>
      <div className="col-span-2 flex items-center gap-2">
        <input type="checkbox" id={`${tid}-attivo`} checked={!!f.attivo} onChange={e=>setF({...f,attivo:e.target.checked})} data-testid={`${tid}-attivo`}/>
        <Label htmlFor={`${tid}-attivo`}>Visibile nel form iscrizioni pubblico</Label>
      </div>
    </div>
  );

  return (
    <div className="p-4 sm:p-8">
      <div className="flex flex-wrap gap-4 items-center justify-between mb-8">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#F7941E] mb-2">Pre-iscrizioni Online</div>
          <h1 className="text-3xl font-bold text-stone-900">Corsi Pubblici</h1>
          <p className="text-stone-600 mt-1">Catalogo visibile nel form iscrizione pubblico — separato dai corsi interni</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="bg-[#F7941E] hover:bg-[#E08316] text-white" data-testid="new-corso-pubblico-btn"><Plus className="w-4 h-4 mr-2"/>Nuovo Corso Pubblico</Button></DialogTrigger>
          <DialogContent className="max-w-2xl">
            <DialogHeader><DialogTitle>Nuovo corso per iscrizioni online</DialogTitle><DialogDescription>Questo catalogo è separato dai corsi interni e alimenta il form pubblico.</DialogDescription></DialogHeader>
            {renderForm(form, setForm, "cp-new")}
            <DialogFooter><Button onClick={save} className="bg-[#F7941E] hover:bg-[#E08316] text-white" data-testid="cp-new-save">Crea</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <Card className="p-4 mb-6 bg-[#FFF5EB] border-[#F5D9B8]">
        <div className="flex items-center gap-3">
          <Link2 className="w-5 h-5 text-[#F7941E]"/>
          <div className="text-sm">
            <span className="font-semibold text-[#C96F0E]">Link pubblico iscrizioni: </span>
            <a href="/iscrizioni-online" target="_blank" rel="noreferrer" className="text-[#F7941E] underline break-all">{window.location.origin}/iscrizioni-online</a>
          </div>
        </div>
      </Card>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {corsi.map(c => (
          <Card key={c.id} className="p-5 bg-white border-[#E2E8F0]" data-testid={`cp-card-${c.id}`}>
            <div className="flex justify-between items-start mb-3">
              <Badge className={CATEGORIE[c.categoria]?.cls || ""}>{CATEGORIE[c.categoria]?.label || c.categoria}</Badge>
              <div className="flex">
                <Button variant="ghost" size="sm" onClick={()=>setEditC({...c})} data-testid={`cp-edit-${c.id}`}><Pencil className="w-4 h-4 text-[#F7941E]"/></Button>
                <Button variant="ghost" size="sm" onClick={()=>del(c.id)} data-testid={`cp-del-${c.id}`}><Trash2 className="w-4 h-4 text-red-500"/></Button>
              </div>
            </div>
            <div className="font-bold text-stone-900 text-lg mb-1">{c.titolo}</div>
            <div className="text-sm text-stone-600 mb-3">{c.descrizione}</div>
            <div className="text-xs text-stone-500 space-y-1">
              <div>Durata: <span className="font-semibold text-stone-900">{c.durata_ore}h</span> · Prezzo: <span className="font-semibold text-[#F7941E]">€ {c.prezzo}</span></div>
              <div>Sede: {c.sede || "-"} {c.data_inizio_prevista && `· Inizio: ${c.data_inizio_prevista}`}</div>
              <div className="flex items-center gap-1">
                {c.attivo
                  ? <Badge className="bg-emerald-50 text-emerald-800"><Globe className="w-3 h-3 mr-1"/>Visibile ({c.posti_disponibili} posti)</Badge>
                  : <Badge className="bg-stone-100 text-stone-600">Nascosto</Badge>}
              </div>
            </div>
          </Card>
        ))}
        {corsi.length === 0 && <div className="col-span-full text-center text-stone-500 py-12">Nessun corso pubblico configurato.</div>}
      </div>

      <Dialog open={!!editC} onOpenChange={(o)=>{if(!o) setEditC(null);}}>
        <DialogContent className="max-w-2xl">
          <DialogHeader><DialogTitle>Modifica corso pubblico</DialogTitle><DialogDescription>Aggiorna i dati del corso visibile nel form iscrizioni online.</DialogDescription></DialogHeader>
          {editC && renderForm(editC, setEditC, "cp-edit")}
          <DialogFooter><Button onClick={saveEdit} className="bg-[#F7941E] hover:bg-[#E08316] text-white" data-testid="cp-edit-save">Salva modifiche</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
